export const FEATURE_FLAGS = [
  {
    name: "new-tender-2",
    local: "control", // control, variant1, variant2
  },
  {
    name: "enable-email-send",
    local: true,
  },
  {
    name: "enable-geolocation",
    local: "test",
  },
  {
    name: "car-mechanic-specify-photo-subheader",
    local: "test", // test or control
  },
  {
    name: "hide-deadline",
    local: "test", // test or control
  },
  {
    name: "enable-google-oauth",
    local: true, // true or false
    fallback: true,
  },
  {
    name: "enable-online-profession",
    local: "variant1", // control, variant1, variant2
  },
  {
    name: "profession-city-page-vertical-card-mobile",
    local: "test", // test or control
  },
  {
    name: "landing-szobafestes-hero",
    local: "test", // test or control
  },
  {
    name: "request-tender-kh-offer",
    local: "test", // test or control
  },
  {
    name: "designers_enabled",
    local: true, // true or false
    fallback: true,
  },
  {
    name: "front-page-hero-subtitles-toggle",
    local: "test", // test or control
  },
];

/**
 * Production values for flags whose feature must keep working when PostHog
 * answers without them (quota limit, outage, timeout, bot traffic). Only real
 * kill switches belong here; experiments without a fallback fall back to
 * their control branch. A flag switched off in PostHog still comes back as
 * `false` and wins over its fallback.
 */
export const FALLBACK_FLAGS = Object.fromEntries(
  FEATURE_FLAGS.filter((flag) => flag.fallback !== undefined).map((flag) => [
    flag.name,
    flag.fallback,
  ])
);
